import React from 'react';
import Container from '@mui/material/Container';
import { useT } from '@transifex/react';
import getPageContent from 'utils/getPageContent';
import { Sidebar } from './components/Sidebar/Sidebar';
import { PageContentProps } from './types';

export const PageContent: React.FC<PageContentProps> = ({
  contentData,
  contentEntries,
  usProductOffers,
  headingData,
  modelPortfolios,
  productInformation,
  sidebarData,
  themeVersion = 'v1',
}) => {
  const t = useT();

  return (
    <React.Fragment>
      {headingData.map((content) =>
        getPageContent(content, t, modelPortfolios, contentEntries, usProductOffers),
      )}
      {!!productInformation?.length && (
        <Container disableGutters>
          {productInformation.map((content) =>
            getPageContent(content, t, modelPortfolios, contentEntries, usProductOffers),
          )}
        </Container>
      )}
      {sidebarData?.length ? (
        <Sidebar
          version={themeVersion}
          sidebar={sidebarData.map((content) =>
            getPageContent(content, t, modelPortfolios, contentEntries, usProductOffers),
          )}
        >
          {contentData.map((content) =>
            getPageContent(content, t, modelPortfolios, contentEntries, usProductOffers),
          )}
        </Sidebar>
      ) : (
        contentData.map((content) =>
          getPageContent(content, t, modelPortfolios, contentEntries, usProductOffers),
        )
      )}
    </React.Fragment>
  );
};
